import { BaseIP } from "../CommonAPI/CommonApi";

//========================= Pending Order Summary ==================================================================================
export const SavePendingOrder=BaseIP+"pendingOrder/newPendingOrder/saveNewPendingOrder"  //To save new pending order in stock 
export const GetPendingOrderList = BaseIP +"pendingOrder/getPendingOrderData"
export const UpdateDiaNumberPendingOrder = BaseIP + "pendingOrder/updateDiaNumber"
export const ClosePendingOrder = BaseIP + "pendingOrder/updateIsCloseStatus"
export const PendingOrderHistory = BaseIP + "pendingOrder/getViewData"

//=========================Order Paper ==============================================================
export const GetOrderByDiaNumber = BaseIP +"pendingOrder/getByDiaNumber"
export const ReportOrderPaper = BaseIP +"reports/orderPaperReport/generateOrderReport"
export const GetOrderByPressNumber = BaseIP +"pendingOrder/getByPressNameId"

